import { AccountSource } from 'owa-graph-schema';
import { action } from 'satcheljs';

export default action(
    'initializeAccountStore',
    (sources: AccountSource[], selectedSourceId: string) => ({
        sources,
        selectedSourceId,
    })
);
